exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-main{-ms-flex:1;flex:1;-ms-flex-preferred-size:auto;flex-basis:auto;overflow:auto;box-sizing:border-box;padding:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader/lib!./~/element-ui/lib/theme-chalk/main.css
// module id = 192
// module chunks = 0